import { Box, IconBadge, StatusLabel } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { SeeRules } from './SeeRules'

interface Props {
  description: string | null | undefined
}

export const AutoApproved = ({ description }: Props) => {
  return (
    <>
      <Box
        padding="s16"
        border={{
          top: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        flexDirection="row"
        gap="s24"
        alignItems="center"
      >
        <IconBadge icon="ai" size="s32" />
        <StatusLabel type="positive">
          {i18n.t('settings.approvals.approval_request_view.approval_history.auto_approve')}
        </StatusLabel>
      </Box>

      <SeeRules description={description} />
    </>
  )
}
